import { useCallback } from 'react';

import Buy from '../../models/Engines/Buy';
import EnginesService from '../../services/EnginesService';
import CollectionResponse from '../../types/CollectionResponse';
import ErrorResponse from '../../types/ErrorResponse';
import useListQuery from '../useListQuery';

const useEnginesBuysListQuery = () => {
	const fetcher = useCallback(
		async (
			dataSetter: (data: CollectionResponse<Buy>) => void,
			errorSetter: (error: ErrorResponse) => void,
			domain: string,
		) => {
			await new EnginesService().buysList(domain, dataSetter, errorSetter);
		},
		[],
	);

	return useListQuery(fetcher);
};

export default useEnginesBuysListQuery;
